export const nutritionSearchInitialValues = {
  dishes: "",
  suplementation: "",
  meal: undefined,
  page: 1,
  objective: undefined,
};

export type NutritionSearchValues = typeof nutritionSearchInitialValues;
